import React from 'react';
import Main from '@components/pages/Main/Main';
import GlobalFontsStyled from '@components/hoc/Theme/Theme.styled';
import { GTMProvider } from '@components/hoc/GTM/GTM';
import { formConfig } from '@config/formConfig';

const GTMParams = formConfig.gtm;

const Layout = () => {
  return (
    <GTMProvider state={GTMParams}>
      <div style={{ padding: 0 }}>
        <GlobalFontsStyled />
        <Main />
      </div>
    </GTMProvider>
  );
};

export default Layout;
